import React from 'react';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';

function Footer() {
  const contactNumber = process.env.REACT_APP_CONTACT_NUMBER;
  const privacyPolicyUrl = process.env.REACT_APP_PRIVACY_POLICY_URL;
  const cookiePolicyUrl = process.env.REACT_APP_COOKIE_POLICY_URL;
  const version = process.env.REACT_APP_VERSION;

  return (
    <footer style={{
      width: '100%',
      minHeight: '230px',
      backgroundColor: '#333',
      color: 'white',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        fontSize: '24px',
        padding: '60px'
      }}>
        <HeadsetMicIcon style={{ marginRight: '10px', color: 'white' }} fontSize="large" />
        Contáctanos en el {contactNumber}
      </div>
      <div style={{
        fontSize: '14px',
        padding: '80px'
      }}>
        <p style={{ marginLeft: '18px' }}>© 2024 Konecta All Rights Reserved.</p>
        <a href={privacyPolicyUrl} style={{ color: 'white', marginRight: '15px' }}>Política de privacidad</a>
        <a href={cookiePolicyUrl} style={{ color: 'white' }}>Política de cookies</a><br />
        <p style={{ marginLeft: '95px' }}>Versión {version}</p>
      </div>
    </footer>
  );
}

export default Footer;
